import { CountryCodeMappings } from "@/types/frontend";
import _ from "lodash";
import moment from "moment";

export class Helpers {
    getUniqueKey(): string {
        return this.uuid4();
    }

    uuid4(): string {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,
            function(c) {
                const r = Math.random() * 16 | 0, v = c == "x" ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
    }

    formatDate(date: string, dateFormat = "Do MMMM YYYY"): string {
        return moment(date).format(dateFormat);
    }

    resolveCountry(value: string): string {
        const countryCodeMappings = this.countryCodeMappings() as CountryCodeMappings;
        const countryCodes = _.keys(countryCodeMappings)!;
        const country = _.toLower(value);
        if (_.includes(countryCodes, country)) {
            return _.startCase(countryCodeMappings[country as keyof CountryCodeMappings]);
        }

        if (_.includes(countryCodeMappings, country)) {
            return _.startCase(value);
        }

        return _.startCase(value);
    }

    countryCodeMappings() {
        return {
            af: "afghanistan",
            ax: "aland islands",
            al: "albania",
            dz: "algeria",
            ad: "andorra",
            ao: "angola",
            ai: "anguilla",
            ag: "antigua and barbuda",
            ar: "argentina",
            am: "armenia",
            aw: "aruba",
            ac: "ascension island",
            au: "australia",
            at: "austria",
            az: "azerbaijan",
            bs: "bahamas",
            bh: "bahrain",
            bd: "bangladesh",
            bb: "barbados",
            by: "belarus",
            be: "belgium",
            bz: "belize",
            bj: "benin",
            bm: "bermuda",
            bt: "bhutan",
            bo: "bolivia",
            ba: "botswana",
            br: "brazil",
            io: "british indian ocean territory",
            vg: "virgin islands, british",
            bn: "brunei",
            bg: "bulgaria",
            bf: "burkina faso",
            bi: "burundi",
            kh: "cambodia",
            cm: "republic of cameroon",
            ca: "canada",
            cv: "cape verde",
            bq: "caribbean netherlands",
            ky: "cayman islands",
            cf: "central african republic",
            td: "chad",
            cl: "chile",
            cn: "china",
            cx: "christmas island",
            cc: "cocos (keeling) islands",
            co: "colombia",
            km: "comoros",
            cg: "congo",
            cd: "congo - kinshasa",
            ck: "cook",
            cr: "costa rica",
            hr: "croatia",
            cw: "curacao",
            cy: "cyprus",
            cz: "czech republic",
            ci: "cote divoire",
            dk: "denmark",
            dj: "djibouti",
            dm: "dominica",
            do: "dominican republic",
            ec: "ecuador",
            eg: "egypt",
            sv: "el salvador",
            gq: "equatorial guinea",
            er: "eritrea",
            ee: "estonia",
            sz: "eswatini",
            et: "ethiopia",
            fk: "falkland islands",
            fo: "faroe",
            fj: "fiji",
            fi: "finland",
            fr: "france",
            gf: "french guiana",
            pf: "french polynesia",
            tf: "french southern territories",
            ga: "gabon",
            gm: "gambia",
            ge: "georgia",
            de: "germany",
            gh: "ghana",
            gi: "gibraltar",
            gr: "greece",
            gl: "greenland",
            gd: "grenada",
            gp: "guadeloupe",
            gt: "guatemala",
            gg: "guernsey",
            gn: "guinea",
            gw: "guinea bissau",
            gy: "guyana",
            ht: "haiti",
            hn: "honduras",
            hk: "hong kong",
            hu: "hungary",
            is: "iceland",
            in: "india",
            id: "indonesia",
            iq: "iraq",
            ie: "ireland",
            im: "isle of man",
            il: "israel",
            it: "italy",
            jm: "jamaica",
            jp: "japan",
            je: "jersey",
            jo: "jordan",
            kz: "kazakhstan",
            ke: "kenya",
            ki: "kiribati",
            xk: "kosovo",
            kw: "kuwait",
            kg: "kyrgyzstan",
            la: "laos",
            lb: "lebanon",
            ls: "lesotho",
            lr: "liberia",
            ly: "libya",
            li: "liecht",
            lt: "lithuania",
            lu: "luxembourg",
            mo: "macao",
            mg: "madagascar",
            mw: "malawi",
            my: "malaysia",
            mv: "maldives",
            ml: "mali",
            mt: "malta",
            mq: "martinique",
            mr: "mauritania",
            mu: "mauritius",
            yt: "mayotte",
            mx: "mexico",
            md: "moldova",
            mc: "monaco",
            mn: "mongolia",
            me: "montenegro",
            ms: "montserrat",
            ma: "morocco",
            mz: "mozambique",
            mm: "myanmar",
            na: "namibia",
            nr: "nauru",
            np: "nepal",
            nl: "netherlands",
            nc: "new caledonia",
            nz: "new zealand",
            ni: "nicaragua",
            ne: "niger",
            ng: "nigeria",
            nu: "niue",
            nf: "norfolk island",
            mk: "north macedonia",
            no: "norway",
            om: "oman",
            pk: "pakistan",
            ps: "palestinian territory",
            pg: "papua new guinea",
            py: "paraguay",
            pe: "peru",
            ph: "philippines",
            pn: "pitcairn",
            pl: "poland",
            pt: "portugal",
            qa: "qatar",
            re: "reunion",
            ro: "romania",
            ru: "russia",
            rw: "rwanda",
            ws: "samoa",
            sm: "san marino",
            st: "sao tome and principe",
            sa: "saudi arabia",
            sn: "senegal",
            rs: "serbia",
            sc: "seychelles",
            sl: "sierra leone",
            sg: "singapore",
            sx: "sint maarten",
            sk: "slovakia",
            si: "slovenia",
            sb: "solomon islands",
            so: "somalia",
            za: "south africa",
            gs: "south georgia and the south sandwich islands",
            kr: "south korea",
            ss: "south sudan",
            es: "spain",
            lk: "sri lanka",
            bl: "saint barthelemy",
            sh: "st helena",
            kn: "saint kitts and nevis",
            lc: "st lucia",
            mf: "st martin",
            pm: "saint pierre",
            vc: "st. vincent",
            sd: "sudan",
            sr: "suriname",
            sj: "svalbard and jan mayen",
            se: "sweden",
            ch: "switzerland",
            tw: "taiwan",
            tj: "tajikistan",
            tz: "tanzania",
            th: "thailand",
            tl: "timor leste",
            tg: "togo",
            tk: "tokelau",
            to: "tonga",
            tt: "trinidad and tobago",
            ta: "tristan da cunha",
            tn: "tunisia",
            tr: "turkey",
            tm: "turkmenistan",
            tc: "turks and caicos islands",
            tv: "tuvalu",
            um: "united states minor outlying islands",
            ug: "uganda",
            ua: "ukraine",
            ae: "united arab emirates",
            gb: "united kingdom",
            uk: "united kingdom",
            us: "united states",
            uy: "uruguay",
            uz: "uzbekistan",
            vu: "vanuatu",
            va: "vatican city",
            ve: "venezuela",
            vn: "vietnam",
            wf: "wallis and futuna",
            eh: "western sahara",
            ye: "yemen",
            zm: "zambia",
            zw: "zimbabwe"
        };
    }
}

export const helpers = new Helpers();
